import styled from 'styled-components';

// Success Splash Elements
export const Button = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
	padding: 16px 24px;
	border-radius: 100px;
	background: rgba(255, 255, 255, 0.05);
	transition: 250ms all;

	backdrop-filter: blur(12px);
	color: #E5E4EC;
	font-size: 13px;
	font-weight: 600;
	line-height: 16px;

	&.link {
		display: flex;
		justify-content: center;
		align-items: center;
		color: #E5E4EC;
		cursor: pointer;
		gap: 8px;
		box-shadow: none;

		svg {
			margin-right: 0;
		}

		&.config-page {
			background: transparent;
		}
	}

	&.success {
		border: 1px solid #BFBBCF;
	}

	// Conference View Config Button Styles
	width: fit-content;

	label, path, a {
		transition: 250ms all;
	}

	:hover {
		background: rgba(255, 255, 255, 0.15);
	}

	:active {
		background: rgba(255, 255, 255, 0.05);

		label, a {
			color: #BFBBCF !important;
		}

		svg>path {
			fill: #BFBBCF !important;
		}
	}

	&.transparent {
		background: transparent;
	}

	&.gradient {
		@property --gradColor1 {
			syntax: '<color>';
			initial-value: rgba(255, 255, 255, 0);
			inherits: false;
		}

		@property --gradColor2 {
			syntax: '<color>';
			initial-value: rgba(255, 255, 255, 0);
			inherits: false;
		}

		background: linear-gradient(0deg, var(--gradColor1) 0%, var(--gradColor2) 100%), linear-gradient(90deg, #FF6AE6 0%, #FFF85C 100%); 
  		transition: --gradColor1 250ms, --gradColor2 250ms;

		:hover {
			--gradColor1: rgba(255, 255, 255, 0.10);
  			--gradColor2: rgba(255, 255, 255, 0.10);
		}
		
		:active {
			--gradColor1: rgba(0, 0, 0, 0.20);
  			--gradColor2: rgba(0, 0, 0, 0.20);

			label {
				color: #09090A !important;
			}

			svg>path {
				fill: #09090A !important;
			}
		}
	}
`;

export const ButtonLabel = styled.label`
	font-size: 13px;
	font-weight: 600;
	line-height: 16px;
	cursor: pointer;
`;

// Conference View Config Elements
export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const ContainerHeader = styled.h2`
	font-size: 30px;
	font-weight: 700;
	line-height: 40px;
	background: linear-gradient(104.42deg, #ff6ae6 -4.67%, #fff85c 69.07%, #a6ff79 120.95%);
	background-clip: text;
	-webkit-text-fill-color: transparent;
	margin: 0 0 8px 0;
`;

export const ContainerSubHeader = styled.h4`
	font-size: 20px;
	font-weight: 600;
	line-height: 32px;
	letter-spacing: -0.2px;
	color: #FFF;
	margin: 0;
`;

export const ConfigContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	padding: 0 20px;
`;

export const ViewOptionsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 16px;
	width: 100%;
	margin: 24px auto 0;
`;

export const ViewOption = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-self: stretch;
	align-items: center;
	width: 320px;
	height: 239px;
	padding: 16px;
	border-radius: 16px;
	cursor: pointer;
	text-align: center;
	gap: 5.316px;
	border-radius: 16px;
	backdrop-filter: blur(16px);

	@property --viewGradColor1 {
		syntax: '<color>';
		initial-value: rgba(0, 0, 0, 0.40);
		inherits: false;
	}

	@property --viewGradColor2 {
		syntax: '<color>';
		initial-value: rgba(0, 0, 0, 0.40);
		inherits: false;
	}

	background-image: linear-gradient(90deg, var(--viewGradColor1) 0%, var(--viewGradColor2) 100%);
	transition: --viewGradColor1 0.2s, --viewGradColor2 0.2s, box-shadow 0.2s ease-in-out;

	h3 {
		color: #E5E4EC;
		text-align: center;
		font-size: 16px;
		font-weight: 600;
		line-height: 20px;
		margin: 0;
		transition: color 0.2s ease-in-out;
	}

	p {
		color: #E5E4EC;
		text-align: center;
		font-size: 11px;
		font-weight: 600;
		line-height: 16px;
		letter-spacing: 0.22px;
		margin: 0;
		transition: color 0.2s ease-in-out;
	}

	:hover {
		--viewGradColor1: rgba(255, 106, 230, 0.40);
		--viewGradColor2: rgba(255, 248, 92, 0.40);
	}

	&.selected {
		--viewGradColor1: #FF6AE6;
		--viewGradColor2: #FFF85C;
		box-shadow: -6px 2px 20px 0px rgba(255, 253, 98, 0.35), 6px -2px 20px 0px rgba(255, 106, 230, 0.35);

		h3, p, svg {
			color: #09090A;
		}

		svg > path, svg > rect {
			transition: fill 0.2s ease-in-out;
			fill: #09090A !important;
		}
	}
`;

export const SubOptions = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 16px;
	width: 100%;
	margin: 24px auto 16px;
`;

export const AnimatedWrapper = styled.div`
	grid-column: 1 / -1;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 16px;
	height: 0;
	opacity: 0;
	overflow: hidden;
	transition: height 0.3s ease-in-out, opacity 0.2s ease-in-out;

	&.visible {
		height: 40px;
		opacity: 1;
	}
`;

export const LocationContainer = styled.div`
	position: relative;
	width: 100%;
	max-width: 320px;
`;

export const EntryDropdownButton = styled.button`
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 40px;
	padding: 12px 16px;
	gap: 8px;
	background: transparent;
	border-radius: 20px;
	border: 1px solid #908CA0;
	width: 100%;

	:hover, :active {
		background: transparent;
	}

	&.open {
		border: 1px solid #E5E4EC;
	}

	&.single {
		padding-right: 32px;
		cursor: default;
	}
`;

export const EntryDropdownButtonText = styled.h2`
	font-size: 12px;
	font-weight: 500;
	line-height: 16px;
	letter-spacing: 0.24px;
	margin: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	color: #908CA0;

	&.selected {
		color: #FFFFFF;
	}
`;

export const EntryDropdown = styled.div`
	position: absolute;
	top: 48px;
	left: 0;
	width: calc(50% - 8px); /* Match the width of one grid column accounting for gap */
	background: rgba(0, 0, 0, 0.4);
	backdrop-filter: blur(16px);
	border-radius: 12px;
	opacity: 0;
	pointer-events: none;
	transition: opacity 0.2s ease-in-out;
	z-index: 100;

	&.open {
		opacity: 1;
		pointer-events: all;
	}
`;

export const EntryDropdownOption = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 10px 16px;
	background: #312F38;
	min-height: 36px;

	&.header {
		padding: 8px 16px;
		color: #908CA0;
	}

	&:not(.header)&:not(.no-locations) {
		cursor: pointer;

		&:hover {
			background: #3C3A42;
		}
	}
`;

export const CheckboxButton = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	block-size: fit-content;
	padding: 12px 20px;
	gap: 8px;
	border-radius: 100px;
	background: rgba(255, 255, 255, 0.05);
	font-size: 13px;
	font-weight: 600;
	white-space: nowrap;
	transition: 250ms all;
	cursor: pointer;

	input[type=checkbox] {
		width: 12px;
		height: 12px;
		accent-color: #FFFFFF;
		cursor: pointer;
	}

	:hover {
		background: rgba(255, 255, 255, 0.15);
	}

	:active {
		background: rgba(255, 255, 255, 0.05);
	}
`;

// Entry Code Elements
export const EntryCodeContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 142px;
`;

export const CodeBox = styled.input`
    width: 64px;
	height: 80px;
	padding: 14px 16px 14px 16px;
	gap: 8px;
	border-radius: 16px;
	border: none;
	outline: none;
	font-weight: 700;
	font-size: 30px;
	text-align: center;

	&:focus {
		border: 1px solid white;
	}
`;
